import { render, staticRenderFns } from "./paymentsDetails.vue?vue&type=template&id=58f237cb&"
import script from "./paymentsDetails.vue?vue&type=script&lang=js&"
export * from "./paymentsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports